import cx from 'classnames';
import React from 'react';

import './spec-course-lesson-view__stub.scss';

interface Props {
    children: React.ReactNode;
    mix?: string;
}

export const SpecCourseLessonViewStub = React.memo(({ children, mix }: Props) => {
    return <div className={cx('spec-course-lesson-view__stub', mix)}>{children}</div>;
});
